<template>
    <div class="chat-container w-100 position-relative">
        <div class="position-relative" v-if="scrollPosition>=0">
            <div class="row no-gutters justify-content-center">
                <div class="fixed-top d-block nav-bottom">
                    <div class="custom-container-fluid  px-0">
                        <div class="row justify-content-center no-gutters">
                            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                                <div class="bg-white light-shadow-2">
                                    <div class="w-100">
                                        <div class="row no-gutters">
                                          <div class="col-12 py-2">
                                            <div class="w-100 pl-3">
                                              <div class="d-inline-block align-middle py-2 mr-2 cursor-pointer">
                                                <router-link :to="'/'+getMerchant().code">
                                                  <img src="../../assets/img/icon/back.png" width="25">
                                                </router-link>
                                              </div>
                                              <p class="body-1-2 d-inline-block align-middle mb-0">
                                                Gallery
                                              </p>
                                            </div>
                                          </div>
                                          <div v-if="scrollPosition>140" class="col-12">
                                            <div class="w-100 text-center">
                                              <p class="mx-1 mb-0 py-2 d-inline-block align-middle cursor-pointer" @click="toggleTab('all')" :class="{'body-2-2-3 text-green tab-active': tab_active == 'all', 'body-2-1' : tab_active != 'all'}">
                                                All Photo
                                              </p>
                                              <p class="mx-1 mb-0 py-2 d-inline-block align-middle cursor-pointer" @click="toggleTab('merchant')" :class="{'body-2-2-3 text-green tab-active': tab_active == 'merchant', 'body-2-1' : tab_active != 'merchant'}">
                                                Merchant
                                              </p>
                                              <p class="mx-1 mb-0 py-2 d-inline-block align-middle cursor-pointer" @click="toggleTab('user')" :class="{'body-2-2-3 text-green tab-active': tab_active == 'user', 'body-2-1' : tab_active != 'user'}">
                                                User
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container mt-5 pt-3">
            <div class="pb-3 mb-2">
                <div class="px-1 pt-2 ">
                    <div class="row slim-grid-row">
                        <div class="col-9">
                            <p class="mb-0 heading-5 text-color-dark">{{getMerchant().name}}</p>
                            <!-- <p class="mb-0 body-2-2-1 font-semibold text-color-dark">Quick Bites Restaurant</p> -->
                            <p class="mb-0 body-2-2-1 text-color-dark">{{getMerchant().address}}</p>
                        </div>
                        <div class="col-3">
                            <img :src="getMerchant().image_url"
                                class="text-center w-100 object-fit logo-img"
                                style="vertical-align: -webkit-baseline-middle;">
                        </div>
                    </div>
                </div>
            </div>
            <div class="my-3">
                <div class="w-100 mb-1 border-bottom text-center">
                  <p class="mx-1 mb-0 py-2 d-inline-block align-middle cursor-pointer" @click="toggleTab('all')" :class="{'body-2-2-3 text-green tab-active': tab_active == 'all', 'body-2-1' : tab_active != 'all'}">
                    All Photo
                  </p>
                  <p class="mx-1 mb-0 py-2 d-inline-block align-middle cursor-pointer" @click="toggleTab('merchant')" :class="{'body-2-2-3 text-green tab-active': tab_active == 'merchant', 'body-2-1' : tab_active != 'merchant'}">
                    Merchant
                  </p>
                  <p class="mx-1 mb-0 py-2 d-inline-block align-middle cursor-pointer" @click="toggleTab('user')" :class="{'body-2-2-3 text-green tab-active': tab_active == 'user', 'body-2-1' : tab_active != 'user'}">
                    User
                  </p>
                </div>
            </div>

            <loader v-if="is_load" />
            <div v-else class="row no-gutters mb-2">
                <div class="col-6">
                  <div class="px-1">
                    <template v-for="(data,index) in list_data">
                      <div v-if="((index+1)%2) == 1" :class="{'height-200': Math.floor(((index+1)/2))%2 == 0,'height-400': Math.floor(((index+1)/2))%2 == 1}" class="w-100 mb-2">
                        <img :src="data.image_url" class="img-fit">
                      </div>
                    </template>
                  </div>
                </div>
                <div class="col-6">
                  <div class="px-1">
                    <template v-for="(data,index) in list_data">
                      <div v-if="((index+1)%2) == 0" :class="{'height-200': (((index+1)/2)%2) == 0,'height-400': (((index+1)/2)%2) == 1}" class="w-100 mb-2">
                        <img :src="data.image_url" class="img-fit" />
                      </div>
                    </template>
                  </div>
                </div>
                <div class="col-12">
                  <infinite-loading v-if="last_page > 1" :forceUseInfiniteWrapper="true" spinner="spiral" @infinite="loadPagination">
                    <div slot="no-more"> </div>
                    <div slot="no-results"> </div>
                  </infinite-loading>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import {get} from '@/services/index.js';
  export default {
    data() {
      return {
        scrollPosition: null,
        isOpen: true,
        is_load: false,
        list_data: [],
        page: 1,
        last_page: 0,
        tab_active: 'all'
      }
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      this.getGallery('all');
    },
    methods: {
      ...mapGetters(['getMerchant']),
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      getGallery(){
        this.is_load = true
        get("CORE","merchant-gallery/"+this.getMerchant().id,{
          type: this.tab_active,
          page: 1,
          page_size: 8
        }).then(response=>{
          let res = response.data;
          this.list_data = res.data.data
          this.page = res.data.current_page
          this.last_page = res.data.last_page
          this.is_load = false
        })
      },
      loadPagination($state){
        if ((this.page+1) > this.last_page) {
          $state.complete();
        }else{
          get("CORE","merchant-gallery/"+this.getMerchant().id,{
            type: this.tab_active,
            page: this.page+1,
            page_size: 8
          }).then(response=>{
            let res = response.data;
            for(let i = 0;i < res.data.data.length; i++){
              this.list_data.push(res.data.data[i])
            }
            this.page = res.data.current_page
            this.last_page = res.data.last_page
            $state.loaded();
          })
        }
      },
      toggleTab(data){
        if(this.tab_active != data){
          this.tab_active = data
          this.getGallery()
        }
      }
    }
  }
</script>
<style scoped>
    .tab-active{
      border-bottom: 2px solid #79a33a;
    }
    .height-200{
      height: 150px !important;
    }
    .height-400{
      height: 300px !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/general/GeneralGallery.vue